import { Flex } from '@chakra-ui/react';
import { ChatInput } from 'modules/common/components/Chat/ChatInput';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultPromptButton } from './DefaultPromptButton';
import { DEFAULT_PROMPTS } from './ImproveText.config';

interface UserInputProps {
  onSubmit: (input: string) => void;
  isDisabled: boolean;
}

export const UserInput = memo(({ onSubmit, isDisabled }: UserInputProps) => {
  const { t } = useTranslation('editor_widget_toolbar', {
    useSuspense: false,
    keyPrefix: 'textToolbar.improveText.modal',
  });
  return (
    <Flex flexDirection='column' gap={2}>
      <ChatInput
        onSubmit={onSubmit}
        isDisabled={isDisabled}
        placeholder={isDisabled ? t('loadingPlaceholder') : t('initialPlaceholder')}
      />
      <Flex gap={2} fontWeight='normal' w='full' overflow='auto'>
        {DEFAULT_PROMPTS.map(({ label, instructions, icon }) => (
          <DefaultPromptButton
            key={label}
            icon={icon}
            label={t(label as keyof typeof t)}
            instructions={instructions}
            onImproveText={onSubmit}
            isDisabled={isDisabled}
          />
        ))}
      </Flex>
    </Flex>
  );
});

UserInput.displayName = 'UserInput';
